import React from 'react'
import { auth } from '../firebase';
import * as routes from '../config/routes';

import { withRouter } from 'react-router-dom';
import withAuthentication from './identity/withAuthentication';

class MenuBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: props.active,
            history: props.history,
        }
    }

    componentDidMount() {
      if (auth.currentUser()){
        this.setState({loggedIn: true})
      }
    }

    logout = (event) => {
        auth.doSignOut()
          .then(authUser => {
            this.props.history.push(routes.SIGN_IN);
          })
          .catch(error => {
            console.log(error)
          });
        event.preventDefault();
    }

    render() {
      return (
        <nav className="white lighten-1" >
          <div className="nav-wrapper container valing-wrapper"><div id="logo-container" className="brand-logo">&nbsp; &nbsp; </div>
            <ul className="right">
              { this.state.loggedIn ? (
                <li><a onClick={this.logout}>Logout</a></li>
                ) : false
              }
            </ul>
            <a data-target="nav-mobile" className="sidenav-trigger"><i className="material-icons">menu</i></a>
          </div>
        </nav>
      )
    }
}
    
export default withRouter(withAuthentication(MenuBar));



// WEBPACK FOOTER //
// ./src/components/MenuBar.jsx